<template>
  <div class="inputSearch">
     <input type="text" class="inputSear" :id="id" :name1="expName1" :name2="expName2" v-model="inputText" ref="ipt"
      :placeholder="setPlaceholder"
      :style="{width:setWidth,height:height,}"
      @focus="focusInput"
      @click="clkDownText"
      @keydown="keydown($event)"
      @input="getInputVal(inputText)"
      @blur="blurInput"
      />
      <div class="dataBox" :style="{width:setWidth}" id='hotCountry' v-if="isShow==1 || isShow==2 || isShow==3 ? true : false ">
        <!-- 热门数据 start-->
         <label v-if="isShow==1 ? true : false ">
          <p class="tipsText">Enter country name or two-character code</p>
          <h3>Hot Countries</h3>
          <ul>
            <li v-for="(item,index) in expHotCountry" @click="getText(item)" :key="index" 
            :class="{isActive:index==isIndex}" :id="item.CountryKey" :name1="item.NameEn" :name3="item.NameCh" :name2="item.CountryCode" 
            @mouseover="clearKeydown(index)">
                {{item.NameEn}}({{item.CountryCode}})
            </li>
          </ul>
         </label>
         <!-- 热门数据 end -->
         <!-- 模糊搜索 start -->
         <ul v-if="isShow==2 ? true : false" >
           <li v-for="(item,index) in countryItems" :key="index" @click="getText(item)" :class="{isActive:index==isIndex}" :id="item.CountryKey" :name1="item.CountryNameEn" :name3="item.CountryNameCh" :name2="item.CountryID" 
            @mouseover="clearKeydown(index)">{{item.CountryNameEn}}({{item.CountryID}})</li>
         </ul>
         <ul v-if="isShow==3 ? true : false">
           <li class="sepTipsMsg">No result</li>
         </ul>
        <!-- 模糊搜索 end -->
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import { post, fetch, Del, put } from "../../../ask/axios";
import bus from '../../../ask/eventBus';
  export default {
    props: {
       setPlaceholder: { type: String }, //输入框默认值
       setWidth: { type: String }, //宽度
       height: { type: String }, //高度
      // marginLeft: { type: String }, //高度
      // myClass: {type: String},
      // name:{type:String},
    },
    data () {
      return {
        api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
        isIndex:-1,
        id:"",
        expName1:'',
        expName2:'',

        inputText:'',
        expStartText:'',
        desCountryCH:'',
        expCode:'',
        expCountryKey:'',

        expHotCountry:[], //热门数据
        countryItems:[], //搜索数据

        isShow:0, //是否显示热门数据 1:热门数据显示，2：搜索数据显示
        focusState: false, //点击其他区域就关闭下拉框]

    
                
      }
    },
    created() {
      this.hotFunction(); //热门数据接口
    },
    mounted(){
        //点击其他区域关闭自定义div
      document.addEventListener('click',(e) => {
          if(this.isShow==1 || this.isShow==2 || this.isShow==3 ){
            var sp = document.getElementById("hotCountry");
            if(sp && !sp.contains(e.target)) {
              this.isShow=0
            }
          }
        })
    },

    computed: { //计算属性函数
     },

    methods:{
      //---------基础设置方法----------//
      //点击input自动选中里面的值
      focusInput:function(e) {
        this.$refs.ipt.select(); // or e.currentTarget.select();
      },
      blurInput(){
        if(!this.expCountryKey){
           this.inputText=''
        }
      },

      //键盘方法
      keydown(e){
          let showList=0
         if(this.isShow==1){
              showList=this.expHotCountry.length //热门数据
          }else if(this.isShow==2){
             showList=this.countryItems.length //搜索数据
          }

        if (e.keyCode == 40) {//下键
          this.isIndex++;
          if (this.isIndex > showList-1) {
            this.isIndex = 0;
          }
        } else if (e.keyCode == 38) {//上
          this.isIndex--;
          if (this.isIndex < 0) {
            this.isIndex = showList - 1;
          }
        } else if (e.keyCode == 13) {//回车
        let text = document.querySelector('.isActive');
        if(text){
           this.inputText = text.innerText;
           this.expCountryKey = text.getAttribute("id")

           this.expStartText= text.getAttribute('name1')
           this.desCountryCH=text.getAttribute('name3')

           this.expCode= text.getAttribute('name2')

           this.isShow=0
           this.isIndex = -1;
         }  
         
         //传值到父组件
        let expCountryValue = {
            expCounEn: this.expStartText,
            expCounCh: this.desCountryCH,
            expNamePro: this.expCode,
            citykey: this.expCountryKey
          };

       this.$emit('byCountryValue',expCountryValue)
        }
      },
       //鼠标移入时清除键盘事件
      clearKeydown(index){
        this.isIndex = index;
      },

    //----------热门数据------------//
     //点击input 出现下拉内容
      clkDownText(){
        this.isShow=1
      },
      //点击热门数据选中//存值
      getText(item){
        if(this.isShow==1){
        this.expStartText=item.NameEn
        this.desCountryCH=item.NameCh
        
        this.expCode=item.CountryCode
        this.expCountryKey=item.CountryKey
        }else if(this.isShow==2){
          this.expStartText=item.CountryNameEn
          this.desCountryCH=item.CountryNameCh
        
          this.expCode=item.CountryID
          this.expCountryKey=item.CountryKey
        }
        this.inputText= this.expStartText+'('+this.expCode+')' //text赋值
        this.isShow=0 //关闭下拉框
        
        //传值到父组件
        let expCountryValue = {
            expCounEn: this.expStartText,
            expCounCh: this.desCountryCH,
            expNamePro: this.expCode,
            citykey: this.expCountryKey
          };
      
       this.$emit('byCountryValue',expCountryValue)


      },
       //热门数据接口
      hotFunction(){
        let that = this;
        that.api.param={
          "mainCode":'KDHotCountry',
        }
        // this.api.url=this.$api01+"/api/InfoCustomer/Attribute/QueryHotCountry"
        this.api.url=this.$api04 + "/Basics/api/Attribute/QueryHotCountry"
        fetch(this.api.url,this.api.param).then(function(res) {
           // console.log('ddd ' +  JSON.stringify(res))
           if(res.Results){
              that.expHotCountry = res.Results
           }
        });
      },

         //----------搜索城市数据------------//
         //货物input输入框输入值
        getInputVal(val){
          this.searchCity(); //搜索成熟数据接口
          if(!this.inputText){
            this.isShow=1
          }
          this.expCountryKey=''
          //传值到父组件
         let expCountryValue = {
            expCounEn: this.expStartText,
            expCounCh: this.desCountryCH,            
            expNamePro: this.expCode,
            citykey: this.expCountryKey
          };
          this.$emit('byCountryValue',expCountryValue)
         },
      searchCity(){
        let that = this;
        that.api.param={
          "Name":this.inputText,
          "Take":50,
        }
        // this.api.url=this.$api02+"/api/EbayCustomer/Country/EndGetCountry"
        this.api.url=this.$api04 + "/Basics/api/SysRegion/EndGetCountry"
        post(this.api.url,this.api.param).then(function(res){
          if(res.Results){
              if(res.Results.length > 0){               
                  that.countryItems = res.Results
                  that.isShow=2
              }else{
                that.isShow=3
              }
          }          
        });
      },
    }

  }
</script>
<style lang="css" scoped>
.inputSearch{position: relative;}
.inputSear{border:1px solid #ddd;border-radius:5px;padding:0 5px;}

.dataBox{background:#fff;border:1px solid #eee;border-radius:5px;position:absolute;top:31px;left:0px;z-index:66;padding:5px;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);-webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);}
  .dataBox .tipsText{border-bottom:1px solid #eee;padding:3px 0;font-size:12px;color:#999;line-height:16px;}
  .dataBox h3{height:30px;line-height:30px;padding:0 5px;font-size:13px;}
  .dataBox ul li{cursor: pointer;padding:0 10px;margin:0 -5px;color:#888;line-height:30px;font-size:13px}
  .dataBox ul li:hover{background:#f5f5f5;}
  .isActive{background:#f5f5f5;}

  .sepTipsMsg{color:#999;text-align:center;}

  .videoCountry .inputSear{border-radius:30px !important;padding-left:8px !important }
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/expDesCountry.vue